import { IconContent } from '@icons';

export const pencil: IconContent = {
    sm: '<path fill-rule="evenodd" d="M11.297 7.3 8.701 4.702 3.694 9.71l-.49 3.086 3.086-.49 5.007-5.007Zm2.695-2.294L13.998 5l-3-3-.006.006-.504-.504-.707.707-7.023 7.023-.593 3.73L2 14l1.039-.165 3.729-.593 7.023-7.022.707-.708-.506-.506Z" />',
};
